module.exports = __webpack_public_path__ + "img/work-img.1a42a6f1.png";